<template>
  <div class="item" id="pg-tags">
    <div class="left" data-toggle="collapse" data-target="#item-tags" aria-expanded="false" aria-controls="item-tags">
      <p class="text-add-course">Tags</p>
    </div>
    <div id="item-tags" class="text-center rigth collapse width"  aria-labelledby="pg-tags" data-parent="#pg-add-course">
      <div class="content-info">
        <div class="form-info">
          <h4>Quais são os assuntos do seu curso?</h4>
          <br>
          <tags-input
            v-model="tag"
            :tags="tags"
            :autocomplete-items="filteredItems"
            placeholder="Adicionar Tags ao curso"
            @tags-changed="( newTags ) => setTags( newTags )"
          />

          <div class="d-flex justify-content-between mt-5">
            <button
              class="btn px-3"
              data-toggle="collapse"
              data-target="#item-requirements"
              aria-expanded="true"
              aria-controls="item-requirements"
            ><< Requerimentos</button>

            <button
              class="btn px-3"
              data-toggle="collapse"
              data-target="#item-medias"
              aria-expanded="true"
              aria-controls="item-medias"
            >Mídias >></button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//newTags =>  tagsTemp = newTags
//@click="save"

import Axios from 'axios'
import VueTagsInput from '@johmun/vue-tags-input';
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'add-course-tags',
  components: {
    "tags-input": VueTagsInput
  },

  data () {
    return {
      tag: "",
      autocompleteItems: []
    }
  },

  computed: {
    ...mapGetters({
      tags: "getNewCourseTags"
    }),

    filteredItems () {
      return this.autocompleteItems.filter(item => {
        return item.text.toLowerCase().indexOf(this.tag.toLowerCase()) !== -1;
      });
    }
  },

  methods: {
    ...mapActions({
      setTags: "setTags"
    }),

    getTags: function () {
      Axios.get('/tags')
        .then( res => {
          this.autocompleteItems = res.data.data
        })
    }
  },
  mounted() {
    this.getTags()
  }
}
</script>
